import { useContext, useEffect, useRef, useState } from "react"
import { useNavigate } from "react-router-dom";
import { EmptyString, FormTypeAdd, InsertDateFormat, MdrOffUs, MdrOnUs, MdrQrisOnUs, PageSizeOptions } from "utils/Constant"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import moment from "moment";
import Select from 'react-select'
import DatePicker from "components/Input/DatePicker";
import { addSpaceEvery4, CheckResponse, decimal, money, removeNonNumeric } from "utils/helpers";
import Dropdown from "components/Input/Dropdown";
import TrashIcon from "assets/icon/TrashIcon";
import { LocationContext } from "components/layout/MainContainer";
import RevisionIcon from "assets/icon/RevisionIcon";
import PlusIcon from "assets/icon/PlusIcon";
import { useCallApi } from "api/apiHooks";
import { CreditCardDetailCard, PagesTitle } from "components/Cards";
import TransferIcon from "assets/icon/TransferIcon";
import { useModal } from "context/ModalContext";

export default function Transaction(){
    let navigate = useNavigate()

    const { locationId } = useContext(LocationContext)
    const { fetchBeneficiaryList, fetchTransactionCustomerCardList, fetchCustomerCardById, fetchEdcList, fetchTransactionList, fetchInsertTransaction, fetchDeleteTransaction } = useCallApi()
    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const [transactionList, setTransactionList] = useState([])
    const [cardNumber, setCardNumber] = useState(EmptyString)
    const [name, setName] = useState(EmptyString)
    const [expired, setExpired] = useState(EmptyString)
    const [vcc, setVcc] = useState(EmptyString)
    const [mdr, setMdr] = useState(EmptyString)
    const [cardType, setCardType] = useState(EmptyString)
    const [customerCard, setCustomerCard] = useState(EmptyString)
    const [customerCardOptions, setCustomerCardOptions] = useState([])
    const [amount, setAmount] = useState(EmptyString)
    const [trMdr, setTrMdr] = useState(EmptyString)
    const [netto, setNetto] = useState(EmptyString)
    const [mdrEdcOnUs, setMdrEdcOnUs] = useState(EmptyString)
    const [mdrEdcOffUs, setMdrEdcOffUs] = useState(EmptyString)
    const [mdrQrisOnUs, setMdrQrisOnUs] = useState(EmptyString)
    const [mdrQrisOffUs, setMdrQrisOffUs] = useState(EmptyString)
    const [edcData, setEdcData] = useState([])
    const [transactionType, setTransactionType] = useState('OnUs');
    const [edc, setEdc] = useState(EmptyString)
    const [edcOptions, setEdcOptions] = useState([])
    const [transactionDate, setTransactionDate] = useState(new Date())
    const [pageSize, setPageSize] = useState(PageSizeOptions[0].value)
    const [edcType, setEdcType] = useState(EmptyString)
    const [qrisHour, setQrisHour] = useState(moment(new Date()).format("HH"))
    const [qrisMinute, setQrisMinute] = useState(moment(new Date()).format("mm"))
    const [paymentmethod, setPaymentMethod] = useState('1')
    const [paymentmethodOptions, setPaymentMethodOptions] = useState([
        { label: 'Transfer', value: '1' },
        { label: 'Cash', value: '2' },
        { label: 'Cash & Transfer', value: '3' },
        { label: 'Lainnya', value: '4' }
    ])
    const [transferAmount, setTransferAmount] = useState(EmptyString)
    const [cashAmount, setCashAmount] = useState(EmptyString)
    const [remark, setRemark] = useState(EmptyString)
    const [beneficiaryId, setBeneficiaryId] = useState(EmptyString)
    const [beneficiaryOptions, setBeneficiaryOptions] = useState([])
    const [transactionTypeOptions, setTransactionTypeOptions] = useState([
        { label: 'On Us', value: 'OnUs' },
        { label: 'Off Us', value: 'OffUs' },
        { label: 'Qris On Us', value: 'QrisOnUs' },
        { label: 'Qris Off Us', value: 'QrisOffUs' }
    ])

    const debounceRef = useRef(null);

    // Handlers

    const customerCardOnInput = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }

        debounceRef.current = setTimeout(() => {
            fetchTransactionCustomerCardList(e, '', 0, 0, '1', 50, 0).then((res) => {
            if (!res) return

            if (res.data.listData.length > 0) {
                let data = res.data.listData
                let tempArray = []

                for (let i = 0; i < data.length; i++) {
                    tempArray.push({
                        label:
                        addSpaceEvery4(data[i].cardNumber) +
                        " (" +
                        data[i].bankCode.trim() +
                        ") - " +
                        data[i].customerName,
                        value: String(data[i].customerCardId),
                    })
                }

                setCustomerCardOptions(tempArray)
            }
            })
        }, 500) // delay here (ms)
    }
    const beneficiaryOnInput = (e) => {
        if (debounceRef.current) {
            clearTimeout(debounceRef.current)
        }

        debounceRef.current = setTimeout(() => {
            fetchBeneficiaryList('', e, 0, '1', 100, 0).then((res) => {
                if (!CheckResponse(res)) {
                    showFailModal(res.message)
                    return
                }

                if (res.data.listData.length > 0){
                    let data = res.data.listData
                    let tempArray = []

                    for (let i = 0; i < data.length; i++){
                        tempArray.push({ label: data[i].accountName + " - " + data[i].bankCode + " (" + data[i].accountNo + ")", value: String(data[i].beneficiaryId) })
                    }

                    setBeneficiaryOptions(tempArray)
                }
            })
        }, 500) // delay here (ms)
    }

    const customerCardChange = (e) => {
        setLoading({isOpen: true})

        setCustomerCard(e)
        
        fetchCustomerCardById(e.value).then((res) => {
            if (!CheckResponse(res)) {
                showFailModal(res.message)
                return
            }

            let data = res.data

            setCardNumber(data.cardNumber)
            setName(data.customerName)
            setExpired(data.expiredMonth === EmptyString ? "-" : data.expiredMonth + " / " + data.expiredYear ===  EmptyString ? "-" : data.expiredYear)
            setVcc(data.vcc === EmptyString ? "-" : data.vcc)
            setMdr(data.mdr)
            setTrMdr(data.mdr)
            setCardType(data.bankName + " " + data.cardVendorName)

            setLoading({isOpen: false})
        })
    }
    const edcChange = (e) => {
        setEdc(e)
        
        if (edcData.length > 0){
            for(let i=0; i < edcData.length; i++){
                if(edcData[i].edcId == e.value){
                    setMdrEdcOffUs(edcData[i].mdrOff)
                    setMdrEdcOnUs(edcData[i].mdrOn)
                    setMdrQrisOnUs(edcData[i].mdrQrisOn)
                    setMdrQrisOffUs(edcData[i].mdrQrisOff)
                    setEdcType(edcData[i].type)
                }
            }
        }
    }
    const transactionDateChange = (e) => {
        if (e === null) {
            setTransactionDate(new Date())
        }else{
            setTransactionDate(e)
        }
    }
    const amountChange = (e) => {
        fCalculateNetto(e.target.value, trMdr)
        setAmount(money(e.target.value))        
    }
    const trMdrChange = (e) => {
        let inputValue = e.target.value

        if (inputValue !== EmptyString){
            let number = parseInt(inputValue)
            if (number > 100){
                
            }else{
                setTrMdr(decimal(e.target.value))
            }
        }else{
            setTrMdr(decimal(e.target.value))
        }
        
        
    }
    const trMdrKeyUp = (e) => {
        fCalculateNetto(amount, e.target.value)
    }
    const pageSizeChange = (e) => {
        setPageSize(e.value)
    }
    
    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
    const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })

    function fCalculateNetto(amount, mdrInput){
        let xAmount = amount === EmptyString ? 0 : parseFloat(amount.replaceAll(",", ""))
        let xMdr = mdrInput === EmptyString ? 0 : parseFloat(mdrInput)
        let xNetto = xAmount - (xAmount * xMdr / 100)
        // ✅ round down to nearest 1000
        let roundedNetto = Math.floor(xNetto / 1000) * 1000

        setNetto(money(parseInt(xNetto)))
        setTransferAmount(money(parseInt(roundedNetto)))
    }
   
    const saveBtnClick = () => {
        if (validation()){
            setLoading({isOpen: true})

            let trxType = ""

            if (transactionType === MdrOnUs){
                trxType = "1"   // On Us
            }else if (transactionType === MdrOffUs){
                trxType = "2"   // Off Us
            }else if (transactionType === MdrQrisOnUs){
                trxType = "3"   // Qris On Us
            }else{
                trxType = "4"   // Qris Off Us
            }

            let time = qrisHour + ":" + qrisMinute

            fetchInsertTransaction(
                moment(transactionDate).format(InsertDateFormat), 
                customerCard.value, 
                edc.value, 
                mdrEdcOffUs, 
                mdrEdcOnUs, 
                mdrQrisOnUs, 
                mdrQrisOffUs, 
                trxType, 
                amount.replaceAll(',', ''), 
                trMdr, 
                netto.replaceAll(',', ''), 
                parseInt(localStorage.getItem("LocationId")), 
                time, 
                paymentmethod, 
                transferAmount === EmptyString ? 0 : transferAmount.replaceAll(",", ""),
                paymentmethod === "2" ? netto.replaceAll(",", "") : (cashAmount === EmptyString ? 0 : cashAmount.replaceAll(",", "")),
                remark, 
                (beneficiaryId !== null && beneficiaryId !== EmptyString) ? beneficiaryId.value : 0
            ).then((res) => {
                if (!CheckResponse(res)) {
                    showFailModal(res.message)
                    return
                }

                setSuccessModal({ 
                    isOpen: true, 
                    data: { 
                        onSuccess: async () => { 
                            setSuccessModal({isOpen: false})
                            setAmount(EmptyString)
                            setNetto(EmptyString)
                            setTransferAmount(EmptyString)
                            setCashAmount(EmptyString)
                            setRemark(EmptyString)
                            setQrisHour(moment(new Date()).format("HH")) 
                            setQrisMinute(moment(new Date()).format("mm")) 
                        }
                    } 
                })

                fetchTransactionList(new Date(), new Date(), '', '', 0, '1', pageSize, 0, '', parseInt(locationId)).then((res) => {
                    setLoading({isOpen: false})

                    if (!CheckResponse(res)) {
                        showFailModal(res.message)
                        return
                    }

                    setTransactionList(res)
                })
            })
        }
    }
    const deleteBtnClick = async (id, status) => {
        const isConfirmed = await confirm()

        if (isConfirmed) {
            showLoading()

            try {
                fetchDeleteTransaction(id, status).then((res) => {
                    if (!CheckResponse(res)) {
                        setLoading({isOpen: false})

                        showFailModal(res.message)
                        return
                    }

                    fetchTransactionList(new Date(), new Date(), '', '', 0, '1', pageSize, 0, '', parseInt(locationId)).then((res) => {
                        setLoading({isOpen: false})

                        if (!CheckResponse(res)) {
                            showFailModal(res.message)
                            return
                        }

                        setTransactionList(res)
                    })
                })
            } finally {
                hideLoading()
            }
        }
    }

    const validation = () => {
        let isValid = true
        let message = EmptyString

        if (paymentmethod === EmptyString){
            isValid = false
            message = "Payment Method must be selected"
        } else {
            if (paymentmethod === '1' || paymentmethod === '3'){
                if (beneficiaryId === EmptyString || beneficiaryId === null){
                    isValid = false
                    message = "Beneficiary must be selected"
                }
            }
        }

        if (qrisHour === EmptyString || qrisMinute === EmptyString){
            isValid = false
            message = "Transaction Time is required"
        }

        if (customerCard === EmptyString || customerCard === null){
            isValid = false
            message = "Customer Card is required"
        }

        if (edc === EmptyString || edc === null || edc === 0 || typeof edc.value === 'undefined'){
            isValid = false
            message = "EDC is required"
        }

        if (amount === EmptyString){
            isValid = false
            message = "Jumlah Gesek is required"
        }

        if (localStorage.getItem("LocationId") === null || localStorage.getItem("LocationId") === ""){
            isValid = false
            message = "You have no location access, please contact administrator."
        }

        if (isValid){
            return true
        }else{  
            setFailModal({
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }   
                },  
                message: message
            })

            return false
        }
    }
    const showFailModal = (message) => {
        setFailModal({
            isOpen: true,
            data: {
                onSuccess: async () => {
                    setFailModal({isOpen: false})
                }
            },
            message
        })
    }

    useEffect(() => {
        if (localStorage.getItem("LocationId") === null || localStorage.getItem("LocationId") === ""){
            setFailModal({ 
                isOpen: true,
                data: {
                    onSuccess: async () => {
                        setFailModal({isOpen: false})
                    }
                },
                message: "You have no location access, please contact administrator."
            })
        }
        fetchEdcList('', EmptyString, '', '', '1', 1000, 0).then((res) => {
            if (!CheckResponse(res)) {
                setFailModal({ 
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: res.message
                })
            }

            if (res.data.listData.length > 0){
                let data = res.data.listData

                setEdcData(data)
                let tempArray = []

                for (let i = 0; i < data.length; i++){
                    tempArray.push({ label: data[i].bankCode + " - " + data[i].edcName.toUpperCase(), value: String(data[i].edcId) })
                }

                setEdcOptions(tempArray)
                setEdc(tempArray[0].value)
            }
        })
    }, [])

    useEffect(() => {
        if (locationId !== null && locationId !== "" && locationId !== "0"){
            fetchTransactionList(new Date(), new Date(), '', '', 0, '1', pageSize, 0, '', parseInt(locationId)).then((res) => {
                setLoading({isOpen: false})

                if (!CheckResponse(res)) {
                    setFailModal({
                        isOpen: true,
                        data: {
                            onSuccess: async () => {
                                setFailModal({isOpen: false})
                            }
                        },
                        message: res.message
                    })
                    return
                }

                setTransactionList(res)
            })
        }
    }, [pageSize, locationId])

    return(
        <div className="flex flex-col gap-2">
            <PagesTitle title={'Transaction'} />
            
            <div className="flex flex-col md:flex-row mt-2 gap-4">
                {/* Customer Info */}
                <div className="md:w-6/12 sm:border rounded-md sm:p-4 w-full sm:bg-white flex flex-col sm:shadow-md">
                    <div className="hidden sm:block">
                        <span className="font-semibold text-md sm:text-xl">Enter Card Number</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="sm:mt-4">
                        <div>
                            <Select options={customerCardOptions} onInputChange={customerCardOnInput} onChange={customerCardChange} />
                        </div>
                    </div>
                    <div className="mt-4 flex flex-col gap-4 text-sm sm:text-base">
                        <CreditCardDetailCard title='Card Number'>
                            <span>{addSpaceEvery4(cardNumber)}</span>
                        </CreditCardDetailCard>
                        <CreditCardDetailCard title='Name'>
                            <span>{name}</span>
                        </CreditCardDetailCard>
                        <CreditCardDetailCard title='Expired'>
                            <span>{expired}</span>
                        </CreditCardDetailCard>
                        <CreditCardDetailCard title='VCC'>
                            <span>{vcc}</span>
                        </CreditCardDetailCard>
                        <CreditCardDetailCard title='MDR'>
                            <span>{mdr}</span>
                        </CreditCardDetailCard>
                        <CreditCardDetailCard title='Card Type'>
                            <span>{cardType}</span>
                        </CreditCardDetailCard>
                    </div>
                </div>

                {/* Transaction Form */}
                <div className="md:w-6/12 sm:border rounded-md sm:p-4 w-full bg-white flex flex-col sm:shadow-md">
                    <div>
                        <span className="font-semibold text-xl">Transaction Form</span>
                        <hr className="mt-2" />
                    </div>
                    <div className="mt-4 flex flex-col gap-4">
                        <Card title="Tanggal Transaksi">
                            <DatePicker className="w-full h-10" value={transactionDate} onChange={transactionDateChange} />
                        </Card>

                        <Card title="Mesin">
                            <Select options={edcOptions} value={edc} onChange={edcChange} />
                        </Card>

                        <div className="flex flex-col sm:flex-row sm:items-center">
                            <div className="min-w-48">
                                <span className="text-sm sm:text-base">Tipe</span>
                            </div>
                            <div className="px-2 hidden sm:block">
                                <span>:</span>
                            </div>
                            <div className="flex flex-wrap gap-2 items-center">
                                {transactionTypeOptions?.map((data, i) => {
                                    return (
                                        <button
                                            className={` 
                                                border rounded-full px-3 py-1 text-sm
                                                ${transactionType === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                            onClick={() => { setTransactionType(data.value) }}
                                            key={i}
                                        >
                                            { data.label }
                                        </button>
                                    )
                                })}
                            </div>
                        </div>

                        <Card title="Waktu Transaksi">
                            <div className="flex">
                                <div className="flex items-center gap-2">
                                    <div className="w-14">
                                        <input className="input" value={qrisHour} onChange={(e) => e.target.value.length > 2 ? null : setQrisHour(removeNonNumeric(e.target.value))} placeholder="HH" />
                                    </div>                                
                                    <span>:</span>
                                    <div className="w-14">
                                        <input className="input" value={qrisMinute} onChange={(e) => e.target.value.length > 2 ? null : setQrisMinute(removeNonNumeric(e.target.value))} placeholder="MM" />
                                    </div>                                
                                </div>

                                <div className="ml-4">
                                    <button className="bg-black p-2 rounded-md"
                                        onClick={() => { 
                                            setQrisHour(moment(new Date()).format("HH")) 
                                            setQrisMinute(moment(new Date()).format("mm")) 
                                        }}
                                    >
                                        <RevisionIcon className="w-6 fill-white" />
                                    </button>
                                </div>
                            </div>    
                        </Card>
                        
                        {/* Amount */}
                        <Card title='Jumlah Gesek'>
                            <input className="input" type="text" inputMode="numeric" value={amount} onChange={amountChange} />
                        </Card>

                        {/* MDR */}
                        <Card title='MDR'>
                            <input className="input" type="text" value={trMdr} onChange={trMdrChange} onKeyUp={trMdrKeyUp} />
                        </Card>

                        {/* Netto */}
                        <Card title='Jumlah Uang Diterima'>
                            <input className="input" value={netto} disabled={true} />
                        </Card>

                        {/* Payment Method */}
                        <Card title='Metode Pembayaran'>
                            <div className="flex gap-2 flex-wrap">
                                {paymentmethodOptions.map((data, i) => {
                                    return(
                                        <button
                                            className={` 
                                                border rounded-full px-3 py-1 text-sm
                                                ${paymentmethod === data.value ? 'bg-black text-white' : 'bg-white text-black'}`}
                                            onClick={() => { setPaymentMethod(data.value) }}
                                            key={i}
                                        >
                                            { data.label }
                                        </button>
                                    )
                                })}
                            </div>
                        </Card>

                        {(paymentmethod === '1' || paymentmethod === '3') && (
                            <div className="flex flex-col gap-4">
                                <Card title='Jumlah Uang Ditransfer'>
                                    <div className="flex gap-2">
                                        <input className="input" value={transferAmount} onChange={(e) => setTransferAmount(money(e.target.value))} disabled={false} />
                                        <button className="bg-black rounded-lg px-3"
                                            onClick={() => { setTransferAmount(netto) }}
                                        >
                                            <TransferIcon className="fill-white w-5" />
                                        </button>
                                    </div>
                                </Card>

                                {paymentmethod === '3' && (
                                    <Card title='Jumlah Uang Cash'>
                                        <input className="input" value={cashAmount} onChange={(e) => setCashAmount(money(e.target.value))} disabled={false} />
                                    </Card>
                                )}

                                {/* Beneficiary Account */}
                                <div className="flex">
                                    <div className="flex flex-col sm:flex-row sm:items-center w-full">
                                        <div className="w-48">
                                            <span className="text-sm sm:text-base">Beneficiary Account</span>
                                        </div>
                                        <div className="px-2 hidden sm:block">
                                            <span>:</span>
                                        </div>
                                        <div className="w-full sm:w-72">
                                            <Select options={beneficiaryOptions} onInputChange={beneficiaryOnInput} value={beneficiaryId} onChange={setBeneficiaryId} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        <Card title='Remark'>
                            <input className="input" value={remark} onChange={(e) => setRemark(e.target.value)} disabled={false} />
                        </Card>
                       
                        <div className="flex gap-2 items-center">
                            <button className="px-4 py-2 bg-lime-600 rounded hover:shadow-lg hover:opacity-85" onClick={saveBtnClick}
                                disabled={localStorage.getItem("LocationId") === null || localStorage.getItem("LocationId") === "" ? true : false}
                            >
                                <span>Gesek</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex flex-col mt-4 gap-4 sm:bg-white sm:shadow-md sm:border rounded-md sm:p-4">
                <div className="flex items-center gap-4">
                    <div>
                        <span>Show </span>
                    </div>
                    <div className="w-20">
                        <Dropdown options={PageSizeOptions} value={pageSize} onChange={pageSizeChange} />
                    </div>
                </div>

                {/* Desktop Size */}
                <div className="hidden sm:block overflow-auto">
                    <table className="w-full border bg-white overflow-auto">
                        <thead>
                            <tr className="h-12">
                                <th className="font-semibold w-16">No</th>
                                <th className="font-semibold text-left px-2 hidden sm:table-cell">Date</th>
                                <th className="font-semibold text-left px-2">Card Number</th>
                                <th className="font-semibold text-left px-2">Name</th>
                                <th className="font-semibold text-left px-2">Card</th>
                                <th className="font-semibold text-left px-2">Gesek</th>
                                <th className="font-semibold text-left px-2">Cash</th>
                                <th className="font-semibold text-left px-2">EDC</th>
                                <th className="font-semibold text-left px-2">Update By</th>
                                <th className="font-semibold sm:w-24">Action</th>
                            </tr>
                        </thead>
                        <tbody className="border">
                            {transactionList?.data?.listData?.map((data, i) => {
                                return(
                                    <tr className="my-2 row h-10 border-y hover:bg-slate-100" key={ i }>
                                        <td className="text-center">{ data.rowNumber }</td>
                                        <td className="px-2 hidden sm:table-cell">
                                            <span>{ moment(data.transactionDate).format("DD MMM yyyy") }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.cardNumber }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.customerName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.bankCode + " - " + data.vendorName }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ money(data.amount) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ money(data.netto) }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.edcBank + " " + data.edcName.toUpperCase() }</span>
                                        </td>
                                        <td className="px-2">
                                            <span>{ data.updateBy }</span>
                                        </td>
                                        <td className={`flex flex-col sm:flex-row justify-center py-2 gap-2 px-2 `}>
                                            <button className={`button flex gap-2`} onClick={() => deleteBtnClick(data.transactionId, data.status)}>
                                                <TrashIcon className="w-4 fill-white" />
                                            </button>
                                        </td>
                                    </tr>
                                )
                            })}
                        </tbody>
                    </table>
                </div>
                
                {/* Mobile Size */}
                <div className="block sm:hidden overflow-auto">
                    <div className="flex flex-col gap-3">
                        {transactionList?.data?.listData?.map((data, i) => {
                            return(
                                <div className="flex flex-col bg-white border-b pb-3">
                                    <div className="flex w-full justify-between">
                                        <div className="flex flex-col">
                                            <div className="flex flex-col">
                                                <label className="text-sm">{data.customerName}</label>
                                                <label className="text-sm">{data.cardNumber}</label>
                                                <label className="text-sm font-semibold">{"Rp " + money(String(Math.floor(data.amount)))}</label>
                                            </div>
                                        </div>
                                        <div className="flex flex-col text-right">
                                            <label className="text-sm">{moment(data.transactionDate).format("DD MMM yyyy")}</label>
                                            <label className="text-sm">{data.mdr}</label>
                                        </div>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <label>{data.edcBank + " - " + data.edcName}</label>
                                        <button className={`bg-black py-1 px-3 rounded-full flex gap-2`} onClick={() => deleteBtnClick(data.transactionId, data.status)}>
                                            <span className="text-xs text-white">Delete</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && ( <LoadingModal onClose={() => setLoading({ isOpen: false })} /> )}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}

const Card = ({ title, children }) => {
    return(
        <div className="flex flex-col sm:flex-row sm:items-center">
            <div className="w-48 text-sm sm:text-base">
                <span>{title}</span>
            </div>
            <div className="px-2 hidden sm:block">
                <span>:</span>
            </div>
            <div className="w-full sm:w-72">
                {children}
            </div>
        </div>
    )
}